module.exports = __webpack_public_path__ + "img/index-noSelected-icon.fcb4fdb8.svg";